/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './../routes/__root'
import { Route as AppRouteImport } from './../routes/_app'
import { Route as AppIndexRouteImport } from './../routes/_app/index'
import { Route as AppAccountRouteImport } from './../routes/_app/account'
import { Route as AuthSignInRouteImport } from './../routes/auth/sign-in'
import { Route as AppContactsIndexRouteImport } from './../routes/_app/contacts/index'
import { Route as AppOrganizationsIndexRouteImport } from './../routes/_app/organizations/index'
import { Route as AppOrganizationsNewRouteImport } from './../routes/_app/organizations/new'
import { Route as AppContactsContactIdIndexRouteImport } from './../routes/_app/contacts/$contactId/index'
import { Route as AppOrganizationsOrganizationIdIndexRouteImport } from './../routes/_app/organizations/$organizationId/index'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountRoute = AppAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AppRoute,
} as any)
const AuthSignInRoute = AuthSignInRouteImport.update({
  id: '/auth/sign-in',
  path: '/auth/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const AppContactsIndexRoute = AppContactsIndexRouteImport.update({
  id: '/contacts/',
  path: '/contacts/',
  getParentRoute: () => AppRoute,
} as any)
const AppOrganizationsIndexRoute = AppOrganizationsIndexRouteImport.update({
  id: '/organizations/',
  path: '/organizations/',
  getParentRoute: () => AppRoute,
} as any)
const AppOrganizationsNewRoute = AppOrganizationsNewRouteImport.update({
  id: '/organizations/new',
  path: '/organizations/new',
  getParentRoute: () => AppRoute,
} as any)
const AppContactsContactIdIndexRoute =
  AppContactsContactIdIndexRouteImport.update({
    id: '/contacts/$contactId/',
    path: '/contacts/$contactId/',
    getParentRoute: () => AppRoute,
  } as any)
const AppOrganizationsOrganizationIdIndexRoute =
  AppOrganizationsOrganizationIdIndexRouteImport.update({
    id: '/organizations/$organizationId/',
    path: '/organizations/$organizationId/',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/account': typeof AppAccountRoute
  '/auth/sign-in': typeof AuthSignInRoute
  '/organizations/new': typeof AppOrganizationsNewRoute
  '/contacts/': typeof AppContactsIndexRoute
  '/organizations/': typeof AppOrganizationsIndexRoute
  '/contacts/$contactId/': typeof AppContactsContactIdIndexRoute
  '/organizations/$organizationId/': typeof AppOrganizationsOrganizationIdIndexRoute
}
export interface FileRoutesByTo {
  '/account': typeof AppAccountRoute
  '/auth/sign-in': typeof AuthSignInRoute
  '/': typeof AppIndexRoute
  '/organizations/new': typeof AppOrganizationsNewRoute
  '/contacts': typeof AppContactsIndexRoute
  '/organizations': typeof AppOrganizationsIndexRoute
  '/contacts/$contactId': typeof AppContactsContactIdIndexRoute
  '/organizations/$organizationId': typeof AppOrganizationsOrganizationIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_app/account': typeof AppAccountRoute
  '/auth/sign-in': typeof AuthSignInRoute
  '/_app/': typeof AppIndexRoute
  '/_app/organizations/new': typeof AppOrganizationsNewRoute
  '/_app/contacts/': typeof AppContactsIndexRoute
  '/_app/organizations/': typeof AppOrganizationsIndexRoute
  '/_app/contacts/$contactId/': typeof AppContactsContactIdIndexRoute
  '/_app/organizations/$organizationId/': typeof AppOrganizationsOrganizationIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/account'
    | '/auth/sign-in'
    | '/organizations/new'
    | '/contacts/'
    | '/organizations/'
    | '/contacts/$contactId/'
    | '/organizations/$organizationId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/account'
    | '/auth/sign-in'
    | '/'
    | '/organizations/new'
    | '/contacts'
    | '/organizations'
    | '/contacts/$contactId'
    | '/organizations/$organizationId'
  id:
    | '__root__'
    | '/_app'
    | '/_app/account'
    | '/auth/sign-in'
    | '/_app/'
    | '/_app/organizations/new'
    | '/_app/contacts/'
    | '/_app/organizations/'
    | '/_app/contacts/$contactId/'
    | '/_app/organizations/$organizationId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  AuthSignInRoute: typeof AuthSignInRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/account': {
      id: '/_app/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AppAccountRouteImport
      parentRoute: typeof AppRoute
    }
    '/auth/sign-in': {
      id: '/auth/sign-in'
      path: '/auth/sign-in'
      fullPath: '/auth/sign-in'
      preLoaderRoute: typeof AuthSignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/contacts/': {
      id: '/_app/contacts/'
      path: '/contacts'
      fullPath: '/contacts/'
      preLoaderRoute: typeof AppContactsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/organizations/': {
      id: '/_app/organizations/'
      path: '/organizations'
      fullPath: '/organizations/'
      preLoaderRoute: typeof AppOrganizationsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/organizations/new': {
      id: '/_app/organizations/new'
      path: '/organizations/new'
      fullPath: '/organizations/new'
      preLoaderRoute: typeof AppOrganizationsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contacts/$contactId/': {
      id: '/_app/contacts/$contactId/'
      path: '/contacts/$contactId'
      fullPath: '/contacts/$contactId/'
      preLoaderRoute: typeof AppContactsContactIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/organizations/$organizationId/': {
      id: '/_app/organizations/$organizationId/'
      path: '/organizations/$organizationId'
      fullPath: '/organizations/$organizationId/'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAccountRoute: typeof AppAccountRoute
  AppIndexRoute: typeof AppIndexRoute
  AppOrganizationsNewRoute: typeof AppOrganizationsNewRoute
  AppContactsIndexRoute: typeof AppContactsIndexRoute
  AppOrganizationsIndexRoute: typeof AppOrganizationsIndexRoute
  AppContactsContactIdIndexRoute: typeof AppContactsContactIdIndexRoute
  AppOrganizationsOrganizationIdIndexRoute: typeof AppOrganizationsOrganizationIdIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAccountRoute: AppAccountRoute,
  AppIndexRoute: AppIndexRoute,
  AppOrganizationsNewRoute: AppOrganizationsNewRoute,
  AppContactsIndexRoute: AppContactsIndexRoute,
  AppOrganizationsIndexRoute: AppOrganizationsIndexRoute,
  AppContactsContactIdIndexRoute: AppContactsContactIdIndexRoute,
  AppOrganizationsOrganizationIdIndexRoute:
    AppOrganizationsOrganizationIdIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  AuthSignInRoute: AuthSignInRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
